/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./transformersEdit.vue?vue&type=template&id=70d77a38&scoped=true"
import script from "./transformersEdit.vue?vue&type=script&lang=js"
export * from "./transformersEdit.vue?vue&type=script&lang=js"
import style0 from "./transformersEdit.vue?vue&type=style&index=0&id=70d77a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d77a38",
  null
  
)

export default component.exports